import { SocketStateInterface } from 'src/store/socket/state';

export function isConnected(state: SocketStateInterface) {
  return state.isConnected;
}

export function getLestMessage(state: SocketStateInterface) {
  return state.message;
}

export function getReconnectError(state: SocketStateInterface) {
  return state.reconnectError;
}
